"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var WindowItemHistoryTable =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemHistoryTable, _DomainObject_1$Domai);

  function WindowItemHistoryTable(promotionCode, promotionType, promotionName, windowType, promoPrice, promoVolume, realVolume, windowDateFrom, windowDateTo, daysValid, numberOfStores, secondaryPlacement, osa, regularPrice, onPicture, tvCommercial) {
    var _this;

    _classCallCheck(this, WindowItemHistoryTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemHistoryTable).call(this));
    _this.promotionCode = promotionCode;
    _this.promotionType = promotionType;
    _this.promotionName = promotionName;
    _this.windowType = windowType;
    _this.promoPrice = promoPrice;
    _this.promoVolume = promoVolume;
    _this.realVolume = realVolume;
    _this.windowDateFrom = windowDateFrom;
    _this.windowDateTo = windowDateTo;
    _this.daysValid = daysValid;
    _this.numberOfStores = numberOfStores;
    _this.secondaryPlacement = secondaryPlacement;
    _this.osa = osa;
    _this.regularPrice = regularPrice;
    _this.onPicture = onPicture;
    _this.tvCommercial = tvCommercial;
    return _this;
  }

  return WindowItemHistoryTable;
}(DomainObject_1.DomainObject);

exports.WindowItemHistoryTable = WindowItemHistoryTable;

WindowItemHistoryTable.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemHistoryTable.name);
  return {
    promotionCode: builder.str('promotionCode'),
    promotionType: builder.str('promotionType'),
    promotionName: builder.str('promotionName'),
    windowType: builder.str('windowType'),
    promoPrice: builder.bigNum('promoPrice'),
    promoVolume: builder.bigNum('promoVolume'),
    realVolume: builder.bigNum('realVolume'),
    windowDateFrom: builder.date('windowDateFrom', DateParser_1.DateParser.ISO_PATTERN),
    windowDateTo: builder.date('windowDateTo', DateParser_1.DateParser.ISO_PATTERN),
    daysValid: builder.num('daysValid'),
    numberOfStores: builder.num('numberOfStores'),
    secondaryPlacement: builder.str('secondaryPlacement'),
    osa: builder.bigNum('osa'),
    regularPrice: builder.bigNum('regularPrice'),
    onPicture: builder.bool('onPicture'),
    tvCommercial: builder.bool('tvCommercial')
  };
}();